import * as types from '../mutation-types'
// import { ajaxFun } from '../actions'

// initial state
const state = {
  all: [],
  flag: false,
  time: '',
  my: {},
  myFlag: false,
  myTime: ''
}

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  [types.RECEIVE_EVENTS_ALL] (state, all) {
    state.all = all
    state.flag = true
    state.time = new Date().getTime()
  },

  [types.RECEIVE_EVENTS_MY] (state, my) {
    state.my = my
    state.myFlag = true
    state.myTime = new Date().getTime()
  },
  [types.CLEAR_EVENTS_ALL] (state) {
    state.myFlag = false
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/events.js